<template>
  <div class="detail">

    <!-- <div class="file_list">
      <div
        v-for="(item, index) in List"
        :key="index"
        class="file_list_item"
        :class="{ 'type-3 ': (index + 1) % 3 === 0 }"
        @click="toNext(item)"
      >
        <img
          v-if="item.type === 1"
          :src="item.full_path"
          alt=""
          class="file_list_item_img"
        />
        <img
          v-if="item.type === 2"
          :src="getVideoPoster(item.full_path)"
          alt=""
          class="file_list_item_img"
        />
        <img
          v-if="item.type === 3"
          src="../../assets/alicon/volume.png"
          alt=""
          class="item_audio_img"
        />
        <img
          v-if="item.type === 4"
          src="../../assets/alicon/volume.png"
          alt=""
          class="item_audio_img"
        />
        <img
          v-if="item.type === 5"
          src="../../assets/alicon/volume.png"
          alt=""
          class="item_audio_img"
        />
        <div class="file_list_item_name">{{ item.name }}</div>
      </div>
    </div> -->

    <van-pull-refresh v-model="isRefreshLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        loading-text=""
        error-text=""
        van-clearfix
        @load="onLoad"
        class="file_list"
      >
        <div
          v-for="(item, index) in List"
          :key="index"
          class="file_list_item"
          @click="toNext(item)"
        >
          <img
            v-if="item.type === 1"
            :src="item.full_path"
            alt=""
            class="file_list_item_img"
          />
          <img
            v-if="item.type === 2"
            :src="getVideoPoster(item.full_path)"
            alt=""
            class="file_list_item_img"
          />
          <img
            v-if="item.type >= 3"
            src="../../assets/alicon/volume.png"
            alt=""
            class="item_audio_img"
          />
          <div class="file_list_item_name">{{ item.name }}</div>
        </div>
      </van-list>

      <div class="reserveSeat"></div>
    </van-pull-refresh>

    <!-- <div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        loading-text=""
        error-text=""
        @load="onLoad"
        class="file_list"
      >
        <van-cell 
          v-for="(item, index) in List"
          :key="index"
          class="file_list_item"
          @click="toNext(item)"
        >
        <img
          v-if="item.type === 1"
          :src="item.full_path"
          alt=""
          class="file_list_item_img"
        />
        <img
          v-if="item.type === 2"
          :src="getVideoPoster(item.full_path)"
          alt=""
          class="file_list_item_img"
        />
        <img
          v-if="item.type >= 3"
          src="../../assets/alicon/volume.png"
          alt=""
          class="item_audio_img"
        />
        <div class="file_list_item_name">{{ item.name }}</div>
        </van-cell>
      </van-list>

      <div class="reserveSeat"></div>
    </div> -->

    <div v-if="pageType!=='4'" class="home_btn">
      <Uploader 
        :params="assetForm" 
        :sortId="sortId"
        @UploadSuccessful="UploadSuccessful"
        @UploadErr="UploadErr"
        />
    </div>

    <!-- 图片预览 -->
    <van-overlay :show="isLoading">
        <div class="wrapper" @click.stop>
            <van-loading type="spinner" />
        </div>
    </van-overlay>

  </div>
</template>

<script>
import { GetCommonFile } from '@/api/index';
import { ImagePreview , Toast } from 'vant-green';
import Uploader from '../../components/Tool/Uploader.vue'
export default {
  name: 'detail',
  components: {
    Uploader,
  },
  data() {
    return {
      // ----------------
      // accept: 'image/*,video/*,audio/*', // 接受的文件类型
      assetForm: {
        type: ''
      },

      // --------------------
      pageType: 3,
      List: [
        // {
        //   name: '这是文件这是文件',
        //   type: 1,
        //   src:'https://img.yzcdn.cn/2.jpg'
        // },
      ],
      isShow:false,
      isLoading: false,

      loading: false,
      finished: false,
      isRefreshLoading:false,

      pagination: {
        // 当前是第几页
        page: 0,
        // 一页几条
        size: 30,
        // 一共多少页
        total: 0
      },
    };
  },
  computed: {},

  created() {
    document.title = '素材库';
    this.init()
  },

  methods: {
    // 初始化
    init() {
      this.initPagination()
      // http://file-front.zwstk.cn?username=zmxagent
      this.isLoading = true
      const urlParams = new URLSearchParams(window.location.search);
      this.pageType = urlParams.get('type');
      this.category_id = urlParams.get('id');
      if(this.pageType && this.category_id){
        this.assetForm.type = this.pageType
        this.sortId = this.category_id
        this.loading = true;
        this.gstFileList(this.pageType, this.category_id)
        setTimeout(() => {
          this.loading = false;
        }, 3000);
      } else {
        this.$router.push({
          path: '/404',
          replace: true,
        });
      }
      setTimeout(() => {
        this.isLoading = false
      }, 500);
    },

    // 分页初始化
    initPagination() {
      this.List = []
      this.pagination = {
        page: 1,
        size: 30,
        total: 0
      }
    },

    // 获取文件列表
    gstFileList(type_id, category_id) {
      GetCommonFile({ 
        type_id: type_id,
        category_id :category_id,
        page: this.pagination.page,
        size: this.pagination.size,
      }).then((res) => {
        // this.List = res.data
        this.List.push(...res.data)
        // 加载状态结束
        this.loading = false;
        this.isRefreshLoading = false
        if(res.meta.current_page === res.meta.last_page){
          this.finished = true;
          // Toast('没有更多了！');
        }
      });
    },

    // 加载更多
    onLoad(){
      this.pagination.page++
      this.gstFileList(this.pageType, this.category_id)
    },

    // 获取视频封面
    getVideoPoster(path) {
      const str = path.includes('aliyun') ? '?x-oss-process=video/snapshot,w_120,t_1000,f_jpg,m_fast,ar_auto' : '?vframe/png/offset/1'
      return path + str
    },

    // 前往下一级
    toNext(item) {
      // window.open(item.full_path, '_blank');
      if(item.type === 1){
        // 图片预览
        ImagePreview([item.full_path]);
      } else {
        window.open(item.full_path, '_blank');
      }
      // if(item.type === 1){
      //   // 图片预览
      //   ImagePreview([item.full_path]);
      // } else if(item.type === 2){
      //   const params = {
      //     name:item.name,
      //     full_path:item.full_path,
      //     duration:item.duration
      //   }
      //   // 视频预览
      //   this.$router.push({
      //     path: '/video?video_obj=' + JSON.stringify(params),
      //     replace: true,
      //   });
      // } else if(item.type >= 3){
      //   // 音频预览
      //   Audio = item
      //   this.isAudio = true
      // }
    },

    // 上传成功
    UploadSuccessful(e){
      console.log('上传成功')
      this.initPagination()
      this.gstFileList(this.pageType, this.category_id)
    },
    // 上传失败
    UploadErr(e){
      console.log('失败')
    },


    // 下拉刷新
    onRefresh() {
      setTimeout(() => {
        this.$toast('刷新成功');
        this.initPagination()
        this.gstFileList(this.pageType, this.category_id)
      }, 500);
    }
  },
};
</script>
<style lang="scss" scoped>
.detail {
  position: relative;
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  .file_list {
    position: relative;
    top: 20px;
    display: flex;
    flex-wrap: wrap;
    // align-items: center;
    align-items:flex-end;
    border: none;
    // border: 1px solid red;
    .file_list_item {
      position: relative;
      margin: 0;
      padding: 0;
      margin-bottom: 20px;
      width: 33%;
      text-align: center !important;
      // padding-left: 5%;
      // border: none;
      
      // border: 1px solid red;
      // display: flex;
      // flex-wrap: wrap;
      // justify-content: center;
      // width: 100px;
      // margin-right: 25px;
      // height: 100px;
      .file_list_item_img {
        // border: 1px solid red;
        // width: 90px;
        // height: 70px;
        margin: 0 auto;
        width: 80%;
        // height: auto; 
        border-radius: 2px;
      }
      .item_audio_img{
        // position: relative;
        // border: 1px solid red;
        // margin: 0 auto;
        width: 66px;
        height: 66px;
        margin-left: 25%;
      }
      .file_list_item_name {
        text-align: center;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-left: 5%;
        max-width: 90%; // 根据需要调整最大宽度
        // border: 1px solid red;
        border-bottom: 3px solid #ffffff;
      }
    }
    .type-3 {
      margin-right: 0px;
    }
  }

  .home_btn {
    position: fixed;
    left: 0;
    bottom: 100px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .btn_sync {
      width: 180px;
    }
  }

  .reserveSeat{
    position: relative;
    width: 100%;
    height: 50px;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
